import { Component, Input, ViewEncapsulation } from '@angular/core';

import { EmailButtonComponent } from '../../components/email-button/email-button.component';
import { EmailLayoutComponent } from '../../components/email-layout/email-layout.component';
import { EmailMarginComponent } from '../../components/email-margin/email-margin.component';
import { EmailMessageHeaderComponent } from '../../components/email-message-header/email-message-header.component';
import { EmailTextComponent } from '../../components/email-text/email-text.component';
import { SsrMarkToUnwrapDirective } from '../../directives/ssr-markto-unwrap.directive';
import type { WrappedValue } from '../../mailgun/wrap-value';
import { MailgunMarkAsHtmlPipe } from '../../pipes/mailgun-mark-as-html.pipe';

@Component({
  selector: 'email-gdpr-auto-consent-template',
  styleUrls: ['../../global-styles.less', './gdpr-auto-consent.component.less'],
  templateUrl: './gdpr-auto-consent.component.html',
  imports: [
    EmailMarginComponent,
    EmailLayoutComponent,
    EmailMessageHeaderComponent,
    EmailTextComponent,
    EmailButtonComponent,
    MailgunMarkAsHtmlPipe,
  ],
  hostDirectives: [SsrMarkToUnwrapDirective],
  // eslint-disable-next-line @angular-eslint/use-component-view-encapsulation
  encapsulation: ViewEncapsulation.None,
})
export class GdprAutoConsentTemplateComponent {
  @Input({ required: true }) public data: WrappedValue<GdprAutoConsentTemplateData>;
}

export type GdprAutoConsentTemplateData = {
  title: string;
  p1: string;
  p2_html: string;
  button_link: string;
  button_text: string;
  footer_html: string;
  message: string;
  company_name: string;
  privacy_policy_link: string | null;
};

export const GdprAutoConsentTemplateMocks: GdprAutoConsentTemplateData[] = [
  {
    title: 'Consent request',
    p1: 'Click "View request" to review terms and accept or decline to provide consent.',
    p2_html:
      "We want you to be in control of your personal data. You can <a href='https://example.com'>request a data correction</a> or <a href='https://example.com'>request to be deleted</a> from our database.",
    message:
      "<p>Hi! <br />Because of data protection laws and regulations, in 30 days we'll have to delete your personal data from our database. If you would like us to continue to store your personal data to match you with future job opportunities, then please click “View consent” and accept the consent.</p>",
    company_name: 'ACME',
    privacy_policy_link: null,
    footer_html: 'Powered by Recruitee',
    button_text: 'View request',
    button_link: 'https://example.com',
  },
];
